import {Platform} from 'react-native';
import {client} from '../helpers/api';

export async function postResubmitPaymentImage({image, transactionId}) {
  const body = new FormData();

  body.append('transaction_id', transactionId);

  if (Platform.OS === 'web') {
    body.append('payment_image', image[0]);
  } else {
    body.append('payment_image', {
      name: image.fileName,
      type: image.type,
      uri:
        Platform.OS === 'android'
          ? image.uri
          : image.uri.replace('file://', ''),
    });
  }

  const response = await client.post('/api/resubmit-payment-image', body, {
    headers: {'Content-Type': 'multipart/form-data'},
  });

  if (response.data?.status) {
    return response.data?.message || 'Payment successfully created.';
  } else if (response.data?.status === false) {
    return response.data?.message || '';
  }
  throw response;
}
